module.exports = __webpack_public_path__ + "img/ia-sensei.dbc4186f.png";